export default __webpack_public_path__ + "static/media/MyPlanImage3.cd748957.jpg";